"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SelectMetadataForm = require("./SelectMetadataForm");
Object.keys(_SelectMetadataForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectMetadataForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectMetadataForm[key];
    }
  });
});